(function() {
  'use strict';

  angular.module('wml.portal.navigation', []);

})();
